export default __webpack_public_path__ + "static/media/icon_economic-workforce-dev.0859cdce.svg";